// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'tiempos', 'tiempos Fallback'"},"className":"__className_9a5ecf","variable":"__variable_9a5ecf"};